export default "__VITE_ASSET__BKGF0N7R__"